import { ConfigProvider, ThemeConfig } from "antd";

const heroTheme: ThemeConfig = {
  components: {
    Input: {
      borderRadiusLG: 4,
      colorText: "#E6E6E6",
      colorBgContainer: "#2D2C80",
      colorTextPlaceholder: "#ADABFF",
    },
    Select: {
      borderRadiusLG: 4,
      colorText: "#E6E6E6",
      colorBgContainer: "#2D2C80",
      colorTextPlaceholder: "#ADABFF",
    },
    Typography: {
      colorText: "#888",
    },
  },
};

const HeroTheme: React.FC<any> = (props) => {
  const { children } = props;
  return <ConfigProvider theme={heroTheme}>{children}</ConfigProvider>;
};

export default HeroTheme;
